class Contact {
    id=0;
    //contactNumber
    createdAt=0;
    typeId=2; //1=enterprise, 2= person
    cpf="";
    cnpj= "";
    ie= "";
    originId=0;
    name= "";
    ownerId="";
    email="";
    streetAddress= "";
    streetAddressNumber=  "";
    streetAddressLine2= "";
    neighborhood =  "";
    zipCode= "";
    cityName =  "";
    phone="";
    avatarUrl="";
    phone="";
   

}


export default Contact;
